import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
@Component({
  selector: 'app-policy-dialog',
  imports: [MatButtonModule, MatDialogModule],
  templateUrl: './policy-dialog.component.html',
  styleUrl: './policy-dialog.component.scss',
})
export class PolicyDialogComponent {}
